import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Spin } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import { getTranslation } from "../../../utils/helper";

const DriversFilterForm = ({ isFetching, query, onSubmit }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const [form] = Form.useForm();

  const nameField = "name";
  const nameValue = query[nameField];

  const emailField = "email";
  const emailValue = query[emailField];

  const phoneField = "phone";
  const phoneValue = query[phoneField];

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  const initialValues = () => {
    const values = {};
    values[nameField] = nameValue;
    values[emailField] = emailValue;
    values[phoneField] = phoneValue;
    return values;
  };

  const handleSubmit = values => {
    const params = {};
    params[nameField] = values[nameField] || null;
    params[emailField] = values[emailField] || null;
    params[phoneField] = values[phoneField] || null;
    onSubmit({ ...query, ...params }, true);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <Form
        form={form}
        onFinish={handleSubmit}
        initialValues={initialValues}
        className="FilterForm DriversFilterForm"
        layout="vertical">
        <div className="FilterFormContent">
          <Row gutter={16}>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Drivers", "Name")} name={nameField}>
                <Input size="large" placeholder={getTranslation(setting, "Drivers", "Name")} />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Drivers", "Email")} name={emailField}>
                <Input size="large" placeholder={getTranslation(setting, "Drivers", "Email")} />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Drivers", "Phone")} name={phoneField}>
                <Input size="large" placeholder={getTranslation(setting, "Drivers", "Phone")} />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="FilterFormActions">
          <Button size="large" type="text" onClick={handleResetButton}>
            {getTranslation(setting, "Common", "Reset")}
            <ReactSVG className="icon" src="/icons/reset.svg" />
          </Button>
          <Button size="large" type="primary" htmlType="submit">
            {getTranslation(setting, "Common", "Apply")}
            <ReactSVG className="icon" src="/icons/apply.svg" />
          </Button>
        </div>
      </Form>
    </Spin>
  );
};

export default DriversFilterForm;
